enum GroupStatus {
  Looking = "Looking",
  Accepted = "Accepted",
  Confirmed = "Confirmed",
  Pending = "Pending",
  Cancelled = "Cancelled",
}

export default GroupStatus;
